// Used to receive notifications from iFrame applications.
// Navigation shell can listen for messages and react accordingly

export const VENUE_CHANGED = "venue_changed";
export const DIALOG_VISIBLE = "dialog_visible";
export const DIALOG_REMOVED = "dialog_removed";
export const USER_UNAUTHENTICATED = "user_unauthenticated";
export const URL_SYNC = "url_sync";

export const navigationChannel = new BroadcastChannel("navigation_channel");
